import { useForm } from 'react-hook-form'
import { FormControl, Stack } from '@chakra-ui/react'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  Button,
  FormErrorMessage,
  FormLabel,
  Input,
  Link,
} from '@opengovsg/design-system-react'
import { z } from 'zod'

import { getNetworkErrorMessage } from '~lib/api'
import { useIsDesktop } from '~hooks/useIsDesktop'

const WHITELISTING_FORM_SG_URL = 'https://form.gov.sg/65ba03141ddc36b393dad77a'

const schema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Please enter an email address.')
    .email({ message: 'Please enter a valid email address.' }),
})

export type LoginFormInputs = {
  email: string
}
interface LoginFormProps {
  onSubmit: (inputs: LoginFormInputs) => Promise<void>
}

export const LoginForm = ({ onSubmit }: LoginFormProps): JSX.Element => {
  const onSubmitForm = async (inputs: LoginFormInputs) => {
    return onSubmit(inputs).catch((e) => {
      setError('email', { type: 'server', message: getNetworkErrorMessage(e) })
    })
  }

  const { handleSubmit, register, formState, setError } =
    useForm<LoginFormInputs>({
      resolver: zodResolver(schema),
    })

  const isDesktop = useIsDesktop()

  return (
    <form noValidate onSubmit={handleSubmit(onSubmitForm)}>
      <FormControl
        isRequired
        isInvalid={!!formState.errors.email}
        isReadOnly={formState.isSubmitting}
        mb="1rem"
      >
        <FormLabel
          description="Log in with a .gov.sg or other whitelisted email address"
          htmlFor="email"
          fontSize={{ base: '1.125rem', lg: '1rem' }}
        >
          Email
        </FormLabel>
        <Input
          autoComplete="email"
          autoFocus
          placeholder="e.g. user@agency.gov.sg"
          {...register('email')}
        />
        <FormErrorMessage>{formState.errors.email?.message}</FormErrorMessage>
      </FormControl>
      <Stack
        direction={{ base: 'column', lg: 'row' }}
        spacing={{ base: '1.5rem', lg: '2.5rem' }}
        align="center"
      >
        <Button
          isFullWidth={!isDesktop}
          isLoading={formState.isSubmitting}
          type="submit"
        >
          Sign in
        </Button>
        <Link target={'_blank'} href={WHITELISTING_FORM_SG_URL}>
          Request whitelisting
        </Link>
      </Stack>
    </form>
  )
}
